export default "/images/smartbox-platform.svg?5523ed6a5ff4b1f2ff93317540bfef08";